function init() {
	setGlobalVariables();
}

function setGlobalVariables(){

	setContainerMarginVariable();

	window.addEventListener('resize', () => {
		
		setContainerMarginVariable();
		
	});

}

function setContainerMarginVariable(){

	var container = document.querySelector('.container');

	if(container){
		var style = container.currentStyle || window.getComputedStyle(container),
			marginLeft = style.marginLeft;
	}

	document.documentElement.style.setProperty('--smx-container-margin', `${marginLeft}`);

}

export default { init };